import { render, staticRenderFns } from "./CompanyMadioniaReport.vue?vue&type=template&id=7220e669&scoped=true&"
import script from "./CompanyMadioniaReport.vue?vue&type=script&lang=js&"
export * from "./CompanyMadioniaReport.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMadioniaReport.vue?vue&type=style&index=0&id=7220e669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220e669",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard-pharma/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VDataTable,VFlex,VIcon,VLayout})
